export default __webpack_public_path__ + "static/media/avicia2.4bd3b7af.webp";